import {ADDRESS} from "../../../../Common/Constants";

export type ShippingAddressInfoJSON = {
  shippingAddressId: number
  familyName: string
  firstName: string
  familyNameKana: string
  firstNameKana: string
  postCode: string
  addressPrefectureCode: string
  addressCity: string
  addressStreet: string
  addressBuilding: string
  phone: string
}

export type ShippingAddressInfo = Pick<ShippingAddressInfoJSON,
  'shippingAddressId' |
  'familyName' |
  'firstName' |
  'familyNameKana' |
  'firstNameKana' |
  'postCode' |
  'addressCity' |
  'addressStreet' |
  'addressBuilding' |
  'phone'> &
  {
    addressPrefecture: string
  }

export class ShippingAddressInfoDTO implements ShippingAddressInfo {
  shippingAddressId: number
  familyName: string
  firstName: string
  familyNameKana: string
  firstNameKana: string
  postCode: string
  addressPrefecture: string
  addressCity: string
  addressStreet: string
  addressBuilding: string
  phone: string

  constructor(shippingAddress: ShippingAddressInfo) {
    this.shippingAddressId = shippingAddress.shippingAddressId
    this.familyName = shippingAddress.familyName
    this.firstName = shippingAddress.firstName
    this.familyNameKana = shippingAddress.familyNameKana
    this.firstNameKana = shippingAddress.firstNameKana
    this.postCode = shippingAddress.postCode
    this.addressPrefecture = shippingAddress.addressPrefecture
    this.addressCity = shippingAddress.addressCity
    this.addressStreet = shippingAddress.addressStreet
    this.addressBuilding = shippingAddress.addressBuilding
    this.phone = shippingAddress.phone
  }

  static fromJSON(jsonObject: ShippingAddressInfoJSON): ShippingAddressInfoDTO {
    const {addressPrefectureCode, ...rest} = jsonObject

    return new ShippingAddressInfoDTO(
      {
      ...rest,
      addressPrefecture: ADDRESS.PREFECTURES[addressPrefectureCode],
    })
  }
}
